/**
 * 주문 리스트 관련 함수 ( 검색 조건 등 )
 */

// 좌측 주문 오더 상태 변경
import { reload_order_list, reload_order_list_all, api_send_order_list } from "../http/OrderConn";
import { select_access_token } from "../http/TokenConn";
import { api_order_search_list } from "http/OrderConn";
import { analyticeEvent, baeminMobileOrderFg, MobileOrderFgMap, posOrderTab } from "utils/Utils";
import { fn_bridge_shopinfo_set, fn_bridge_pos_order_list } from "function/FnPosBridge";
import { fn_hide_search_list } from "function/FnBodySearch";

import React from "react";

export function fn_currOrderType(rootStore, type) {
  select_access_token(rootStore).then(res => {
    rootStore.orderStore.setPagingInfo("page_no", 1);
    rootStore.orderStore.initOrderList();
    rootStore.searchStore.setCurrOrderType(type);
    reload_order_list_all(rootStore, type);
  });
}

export function fn_AllOrderComplete(rootStore) {
  if (rootStore.settingStore.getPosType != "0" && rootStore.settingStore.getPosType != "2") {
    rootStore.layerStore.setLayerAlertType("order_pos");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    analyticeEvent("orderCompleteall", "orderCompleteAll Button", rootStore.searchStore.getShopCd); //GA4
    let check = true;
    let paidData = new Array();
    let noPaidData = new Array();

    rootStore.layerStore.setLayerLoadingView(true);
    if (rootStore.orderStore.getOrderList == null || rootStore.orderStore.getOrderList.length <= 0) {
      rootStore.layerStore.setLayerAlertType("no_all_complete_order");
      rootStore.layerStore.setLayerAlertView(true);
      check = false;
    } else {
      for (let i = 0; i < rootStore.orderStore.getOrderList.length; i++) {
        let oneData = new Object();
        oneData.mobileOrderFg = rootStore.orderStore.getOrderList[i].mobileOrderFg;
        oneData.mobileOrderNo = rootStore.orderStore.getOrderList[i].mobileOrderNo;
        oneData.orderNo = rootStore.orderStore.getOrderList[i].orderNo;
        oneData.morderTypeCd = rootStore.orderStore.getOrderList[i].morderTypeCd;
        oneData.payFg = rootStore.orderStore.getOrderList[i].payFg == "CASH" ? "01" : "02";
        oneData.prePayYn = rootStore.orderStore.getOrderList[i].payType == "PAID" ? "T" : "F";

        if (rootStore.orderStore.getOrderList[i].payType == "PAID") {
          paidData.push(oneData);
        } else {
          noPaidData.push(oneData);
        }
        if (parseInt(rootStore.orderStore.getOrderList[i].stepCd) < 200) {
          check = false;
          rootStore.layerStore.setLayerAlertType("no_all_complete_order_check");
          rootStore.layerStore.setLayerAlertView(true);
          break;
        }
        if (baeminMobileOrderFg(rootStore.orderStore.getOrderList[i].mobileOrderFg)) {
          rootStore.viewStore.setAllCompleteBaeminList(true);
        }
      }
    }

    if (check) {
      rootStore.layerStore.setLayerAlertType("all_complete_order");
      rootStore.layerStore.setLayerAlertView(true);
      rootStore.layerStore.setAllCompletedPaidList(paidData);
      rootStore.layerStore.setAllCompletedNoPaidList(noPaidData);
    }

    paidData = null;
    noPaidData = null;

    rootStore.layerStore.setLayerLoadingView(false);
  }
}

export function fn_completeList(rootStore) {
  analyticeEvent("viewOrderCompleted", "viewOrderCompleted Button", rootStore.searchStore.getShopCd); //GA4
  if (rootStore.settingStore.getManagerSetting?.orderEnd == "Y") {
    rootStore.settingStore.setManagerSetting("orderEnd", "N");
  } else {
    rootStore.settingStore.setManagerSetting("orderEnd", "Y");
  }
  rootStore.searchStore.setCurrStepType("all");
  rootStore.searchStore.setCurrOrderType("all");
  rootStore.orderStore.setPagingInfo("page_no", 1);
  api_order_search_list(rootStore);
  fn_bridge_shopinfo_set(rootStore);
  fn_hide_search_list(rootStore);
}

// 상단 주문 스탭별 상태 변경
export function fn_currStepType(rootStore, type) {
  select_access_token(rootStore).then(res => {
    rootStore.orderStore.setPagingInfo("page_no", 1);
    rootStore.orderStore.initOrderList();
    rootStore.searchStore.setCurrStepType(type);
    reload_order_list_all(rootStore);
  });
}

// 다음페이지
export function fn_nextPage(rootStore) {
  rootStore.orderStore.nextPage();
  if (posOrderTab(rootStore)) {
    fn_bridge_pos_order_list(rootStore);
  } else {
    select_access_token(rootStore).then(res => {
      reload_order_list(rootStore);
    });
  }
}

// 이전페이지지
export function fn_prevPage(rootStore) {
  rootStore.orderStore.prevPage();
  if (posOrderTab(rootStore)) {
    fn_bridge_pos_order_list(rootStore);
  } else {
    select_access_token(rootStore).then(res => {
      reload_order_list(rootStore);
    });
  }
}

// 페이지초기화
export function fn_setInitPage(rootStore) {
  rootStore.settingStore.setKioskOrderState("all");
  select_access_token(rootStore).then(res => {
    rootStore.orderStore.setInitPage();
    reload_order_list(rootStore);
  });
}

// 매출수기 Channel
export function fn_getOrderChannelView(rootStore) {
  return rootStore.orderStore.getOrderChannelView;
}

// 매출수기 Type
export function fn_getOrderTypeView(rootStore) {
  return rootStore.orderStore.getOrderTypeView;
}

// 매출수기 Pay
export function fn_getOrderPayView(rootStore) {
  return rootStore.orderStore.getOrderPayView;
}

// 배민1, 익스프레스 체크
export function fn_checkDlvType(rootStore) {
  fn_setOrderChannelView(rootStore, "type", "D", "배달", true);
  let item = rootStore.orderStore.getOrderRegistList;
  let list = rootStore.orderStore.getOrderRegistAdd;
  let money = 0;

  item.paymentAmount = Number(item.paymentAmount.replaceAll(",", ""));
  item.id = list.length;
  item.mobileOrderFg = MobileOrderFgMap[item.orderChannel] || "";
  rootStore.orderStore.setOrderRegistAdd(item);
  rootStore.orderStore.setTotalRegistInfo("cnt", list.length);
  list.map(element => {
    money += Number(element.paymentAmount);
  });
  rootStore.orderStore.setTotalRegistInfo("money", Number(money));
  //rootStore.orderStore.setInitRegistList()
  document.getElementById("amount").value = "";
  document.getElementById("amount").focus();
  rootStore.orderStore.setInitAmount();
  rootStore.layerStore.setLayerSaleWriteCloseView("confirm", false);
}

//주문list
export function fn_setOrderRegistList(rootStore) {
  let item = rootStore.orderStore.getOrderRegistList;
  let list = rootStore.orderStore.getOrderRegistAdd;
  let money = 0;
  let channelCnt = 0;
  let typeCnt = 0;
  let payCnt = 0;

  for (let value of Object.values(rootStore.orderStore.getOrderChannelView)) if (value) channelCnt++;
  for (let value of Object.values(rootStore.orderStore.getOrderTypeView)) if (value) typeCnt++;
  for (let value of Object.values(rootStore.orderStore.getOrderPayView)) if (value) payCnt++;

  if (list.length < 5) {
    if (channelCnt == 0) {
      rootStore.layerStore.setLayerRequiredAlert("view", true);
      rootStore.layerStore.setLayerRequiredAlert("txt", "주문채널을 선택해주세요");
      return false;
    } else if (typeCnt == 0) {
      rootStore.layerStore.setLayerRequiredAlert("view", true);
      rootStore.layerStore.setLayerRequiredAlert("txt", "주문유형을 선택해주세요");
      return false;
    } else if (payCnt == 0) {
      rootStore.layerStore.setLayerRequiredAlert("view", true);
      rootStore.layerStore.setLayerRequiredAlert("txt", "결제방법을 선택해주세요");
      return false;
    } else if (item.paymentAmount <= 0) {
      rootStore.layerStore.setLayerRequiredAlert("view", true);
      rootStore.layerStore.setLayerRequiredAlert("txt", "매출금액을 입력해주세요");
      return false;
    } else {
      if ((item.orderChannel == "baemin1" || item.orderChannel == "yogiyoexpress") && item.orderType != "D") {
        rootStore.layerStore.setLayerSaleWriteCloseView("confirm", true);
      } else {
        item.paymentAmount = Number(item.paymentAmount.replaceAll(",", ""));
        item.id = list.length;
        item.mobileOrderFg = MobileOrderFgMap[item.orderChannel] || "22";
        rootStore.orderStore.setOrderRegistAdd(item);
        rootStore.orderStore.setTotalRegistInfo("cnt", list.length);
        list.map(element => {
          money += Number(element.paymentAmount);
        });
        rootStore.orderStore.setTotalRegistInfo("money", Number(money));
        //rootStore.orderStore.setInitRegistList()
        document.getElementById("amount").value = "";
        document.getElementById("amount").focus();
        rootStore.orderStore.setInitAmount();
      }
    }
  } else {
    rootStore.layerStore.setLayerRequiredAlert("view", true);
    rootStore.layerStore.setLayerRequiredAlert(
      "txt",
      "한번에 최대 5건까지만 등록 가능합니다.\n매출 임의등록 후 다시 시도해주세요."
    );
    return false;
  }
}

//주문clear
export function fn_orderListClear(rootStore, id) {
  let totalList = rootStore.orderStore.getOrderRegistAdd;
  let money = rootStore.orderStore.getTotalRegistInfo.money;
  let delList = totalList.filter(element => element.id == id);
  let newList = totalList.filter(element => element.id !== id);

  //total 수정
  rootStore.orderStore.setTotalRegistInfo("cnt", totalList.length - 1);
  rootStore.orderStore.setTotalRegistInfo("money", money - Number(delList[0].paymentAmount));

  rootStore.orderStore.setOrderRegistAdd(newList, "del");
}

//주문
export function fn_sendOrderList(rootStore) {
  if (rootStore.orderStore.getOrderRegistAdd.length == 0) {
    rootStore.layerStore.setLayerRequiredAlert("view", true);
    rootStore.layerStore.setLayerRequiredAlert("txt", "임의등록할 매출이 없습니다.\n매출추가 후 재시도 해주세요");
    return false;
  } else {
    //api_send_order_list(rootStore);
    select_access_token(rootStore, false).then(res => {
      if (res) {
        api_send_order_list(rootStore);
      }
    });
  }
}

//매출수기 조건 초기화
export function fn_initDetailButtonView(rootStore) {
  rootStore.orderStore.setInitChannel("channel");
  rootStore.orderStore.setInitChannel("type");
  rootStore.orderStore.setInitChannel("pay");
  //document.getElementById("amount").value = 0;
  document.getElementById("amount").value = "";
}

// 검색 상세버튼 설정
export function fn_setOrderChannelView(rootStore, obj, key, txt, val) {
  if (obj == "channel") {
    rootStore.orderStore.setInitChannel(obj);
    rootStore.orderStore.setOrderChannelView(key, val);
    rootStore.orderStore.setOrderRegistList(obj, txt, key);
  } else if (obj == "type") {
    rootStore.orderStore.setInitChannel(obj);
    rootStore.orderStore.setOrderTypeView(key, val);
    rootStore.orderStore.setOrderRegistList(obj, txt, key);
  } else if (obj == "pay") {
    rootStore.orderStore.setInitChannel(obj);
    rootStore.orderStore.setOrderPayView(key, val);
    rootStore.orderStore.setOrderRegistList(obj, txt, key);
  } else {
    rootStore.orderStore.setOrderRegistList(obj, txt, key); //금액
  }
}

// 검색 상세버튼 초기화
export function fn_initOrderChannelView(rootStore) {
  rootStore.orderStore.initDetailButtonView();
}
